// Copyright (c) 2017 Deere & Company

import OtherInstruction from './other-instruction';
import t from 'tcomb';

const ExternalNotes = t.struct({
    internalNotes: t.list(OtherInstruction, 'OtherInstruction'),
    notes: t.list(OtherInstruction, 'OtherInstruction'),
    pin: t.String
}, {
    name: 'ExternalNotes'
});

export const getDefaultState = () => new ExternalNotes({
    internalNotes: [],
    notes: [],
    pin: ''
});

export default ExternalNotes;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/external-notes.js